import { areaData, BetsTypes, numberOnTheRacetrackValueIndex, racetrackSets } from '../const';

export const getBetColorType = (value: string) => {
  if (value === '0') {
    return BetsTypes.zero;
  }
  // @ts-ignore
  const idx = numberOnTheRacetrackValueIndex[value];
  return idx % 2 > 0 ? BetsTypes.black : BetsTypes.red;
};

const areaDataFirstSet = new Set(areaData[0]);
const areaDataSecondSet = new Set(areaData[1]);
const areaDataLastSet = new Set(areaData[2]);

export const isBlack = (item: string) => getBetColorType(item) === BetsTypes.black;
export const isRed = (item: string) => getBetColorType(item) === BetsTypes.red;
export const isZero = (item: string) => Number(item) === 0;
export const isEven = (item: string) => !isZero(item) && Number(item) % 2 === 0;
export const isOdd = (item: string) => Number(item) % 2 === 1;
export const isFirst = (item: string) => !isZero(item) && Number(item) <= 18;
export const isLast = (item: string) => Number(item) > 18;
export const isFirstDozen = (item: string) => !isZero(item) && Number(item) <= 12;
export const isSecondDozen = (item: string) => Number(item) > 12 && Number(item) <= 24;
export const isLastDozen = (item: string) => Number(item) > 24;
export const isFirstColumn = (item: string) => areaDataFirstSet.has(item);
export const isSecondColumn = (item: string) => areaDataSecondSet.has(item);
export const isLastColumn = (item: string) => areaDataLastSet.has(item);
export const isJeuZero = (item: string) => racetrackSets[BetsTypes.jeuZero].has(item);
export const isVoisins = (item: string) => racetrackSets[BetsTypes.voisins].has(item);
export const isTier = (item: string) => racetrackSets[BetsTypes.tier].has(item);
export const isOrphelins = (item: string) => racetrackSets[BetsTypes.orphelins].has(item);
